import React from 'react';
import { Nav, Button } from 'react-bootstrap';
import { css } from 'twin.macro';
import PropTypes from 'prop-types';

const ActiveArchiveToggle = ({
    isActive,
    setIsActive,
    disabled = false,
    activeLabel = 'Active',
    archiveLabel = 'Archived',
    className = '',
    buttonSize = '1.6rem',
    activeVariant = 'primary',
    archiveVariant = 'link',
    containerStyles,
}) => {
    return (
        <Nav
            variant="pills"
            className={`pl-2 py-1 ${className}`}
            css={[
                css`
                    background: #e1e1e1;
                    border-radius: 5px;
                    width: 17rem;
                `,
                containerStyles,
            ]}
        >
            <Nav.Item className="ml-1">
                <Nav.Link
                    as={Button}
                    variant={isActive ? activeVariant : archiveVariant}
                    onClick={() => setIsActive(true)}
                    style={{ fontSize: buttonSize }}
                    className={isActive ? `bg-${activeVariant} text-white m-1 px-2 py-1` : 'm-1 px-2 py-1'}
                    disabled={disabled}
                >
                    {activeLabel}
                </Nav.Link>
            </Nav.Item>
            <Nav.Item className="ml-1">
                <Nav.Link
                    as={Button}
                    variant={!isActive ? activeVariant : archiveVariant}
                    onClick={() => setIsActive(false)}
                    style={{ fontSize: buttonSize }}
                    className={!isActive ? `bg-${activeVariant} text-white m-1 px-2 py-1` : 'm-1 px-2 py-1'}
                    disabled={disabled}
                >
                    {archiveLabel}
                </Nav.Link>
            </Nav.Item>
        </Nav>
    );
};

ActiveArchiveToggle.propTypes = {
    isActive: PropTypes.bool.isRequired,
    setIsActive: PropTypes.func.isRequired,
    activeLabel: PropTypes.string,
    archiveLabel: PropTypes.string,
    className: PropTypes.string,
    buttonSize: PropTypes.string,
    activeVariant: PropTypes.string,
    archiveVariant: PropTypes.string,
    containerStyles: PropTypes.object,
};

export default ActiveArchiveToggle;
